import { render, staticRenderFns } from "./BlocoHistoricoMonitoramento.vue?vue&type=template&id=1a40366f&scoped=true&lang=pug"
import script from "./BlocoHistoricoMonitoramento.vue?vue&type=script&lang=js"
export * from "./BlocoHistoricoMonitoramento.vue?vue&type=script&lang=js"
import style0 from "./BlocoHistoricoMonitoramento.vue?vue&type=style&index=0&id=1a40366f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a40366f",
  null
  
)

export default component.exports